<!--Multicountry Draft-->

<div
  class="col-sm-3 col-md-3 col-lg-3 custom-multicountry-in"
  (click)="openMultiCountryDraftModal()"
></div>
<div class="right-multicountry-draft">
  <div id="price-reco-main">
    <button
      type="button"
      class="close close-multi-country-draft"
      data-dismiss="modal"
      aria-label="Close"
      (click)="openMultiCountryDraftModal()"
    >
      <span aria-hidden="true">&times;</span>
    </button>

    <div class="col-sm-12 col-md-12">
      <div class="row">
        <div class="recomment-title">
          <label>Multi-Country Drafts</label>
        </div>
      </div>
      <div class="row multi-country-select-all" *ngIf="!isDraftSaved">
        <div class="col-sm-12 col-md-12 multi-country-select-button">
          <button
            type="button"
            class="multi-country-button"
            (click)="selectAllMultiCountry()"
          >
            Select All
          </button>
          <button
            type="button"
            class="multi-country-button"
            (click)="deSelectAllMultiCountry()"
          >
            Clear All
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div
            class="scroll-multi-country-draft"
            [ngClass]="
              isDraftSaved
                ? showLaunchAllButton
                  ? 'max-height-260'
                  : 'max-height-210'
                : 'max-height-340'
            "
          >
            <table class="table multi-country-draft">
              <tr>
                <th>Locale</th>
                <th>CPI</th>
                <th>Feasibility</th>
                <th>IR</th>
                <th *ngIf="isDraftSaved">Delete</th>
              </tr>
              <ng-container
                *ngFor="
                  let multiCountry of multiCountryDraftData.countryData;
                  let i = index
                "
              >
                <tr
                  class="info-row"
                  [class.active]="multiCountry.active"
                  [ngClass]="{
                    'disable-mc-survey':
                      isMcSurveyLoading ||
                      ((isCPILoading ||
                        (multiCountry.psSurveystatus &&
                          multiCountry.psSurveystatus !==
                            surveyStatus.DRAFT)) &&
                        !this.manualProcessing),
                    'mc-survey':
                      multiCountry.psSurveystatus === surveyStatus.DRAFT
                  }"
                >
                  <td
                    (click)="
                      multiCountry.psSurveystatus &&
                      multiCountry.psSurveystatus !== surveyStatus.DRAFT
                        ? false
                        : selectDraftSurvey(i)
                    "
                  >
                    <input
                      *ngIf="!isDraftSaved"
                      type="checkbox"
                      [checked]="multiCountry.checked"
                      (change)="selectMultiCountryDraft($event, i)"
                    />
                    {{ multiCountry.name }}-{{
                      multiCountry.language.transalte_code
                    }}
                  </td>
                  <td>
                    <img
                      alt=""
                      *ngIf="
                        !multiCountry.cpi &&
                        multiCountry.cpi !== 0 &&
                        !multiCountry.isEdit &&
                        !multiCountry.manualProcessingLoading
                      "
                      src="../../../assets/image/small-loader.gif"
                      width="48"
                      height="48"
                    />
                    <ps-ui-ellipsis-loader
                      [show]="
                        multiCountry.manualProcessingLoading
                          ? multiCountry.manualProcessingLoading
                          : false
                      "
                      [ngClass]="{
                        'manual-processing-loader-hide':
                          !multiCountry.manualProcessingLoading
                      }"
                    >
                    </ps-ui-ellipsis-loader>
                    <div
                      class="hover-edit-trigger"
                      title="click to edit"
                      *ngIf="!multiCountry.manualProcessingLoading"
                    >
                      <div
                        class="hover-text-field"
                        *ngIf="!multiCountry.isEdit"
                        (click)="
                          isServiceBuyerOperation
                            ? $event.stopPropagation()
                            : updateMultiCountryisEdit(multiCountry)
                        "
                      >
                        <span *ngIf="multiCountry.cpi || multiCountry.cpi === 0"
                          >{{ multiCountry.currency_symbol
                          }}{{ multiCountry.cpi | number : '1.2-2' }}</span
                        >
                        <div
                          class="pencil-outer pencil-outer-qbp"
                          *ngIf="
                            isDraftSaved &&
                            !showLaunchAllButton &&
                            overrideEnable &&
                            !isServiceBuyerOperation
                          "
                          (click)="updateMultiCountryisEdit(multiCountry)"
                        >
                          <div class="fa fa-pencil"></div>
                        </div>
                      </div>
                      <input
                        class="inputText hover-font-color input-qbp-cpi"
                        type="inputText"
                        [ngModel]="multiCountry.cpi"
                        (ngModelChange)="onCpiChange($event, multiCountry)"
                        *ngIf="multiCountry.isEdit"
                        (keyup.enter)="updateCurrentCpi(multiCountry)"
                        psUiInputRestriction="[0-9.]"
                        psUiInputDecimalRestriction
                      />
                      <div
                        class="edit-button-group"
                        *ngIf="multiCountry.isEdit"
                      >
                        <div
                          class="fa fa-check glyphicon glyphicon-ok"
                          (click)="updateCurrentCpi(multiCountry)"
                        ></div>
                        <div
                          class="fa fa-remove glyphicon glyphicon-remove"
                          (click)="setMulticountrySurveyCpi(multiCountry)"
                        ></div>
                      </div>
                    </div>
                  </td>
                  <td
                    (click)="
                      multiCountry.psSurveystatus &&
                      multiCountry.psSurveystatus !== surveyStatus.DRAFT
                        ? false
                        : selectDraftSurvey(i)
                    "
                  >
                    <img
                      alt=""
                      *ngIf="
                        !multiCountry.feasibility &&
                        multiCountry.feasibility !== 0 &&
                        !multiCountry.manualProcessingLoading
                      "
                      src="../../../assets/image/small-loader.gif"
                      width="48"
                      height="48"
                    />

                    <ps-ui-ellipsis-loader
                      [show]="
                        multiCountry.manualProcessingLoading
                          ? multiCountry.manualProcessingLoading
                          : false
                      "
                      [ngClass]="{
                        'manual-processing-loader-hide':
                          !multiCountry.manualProcessingLoading
                      }"
                    >
                    </ps-ui-ellipsis-loader>
                    <span
                      *ngIf="
                        (multiCountry.feasibility ||
                          multiCountry.feasibility === 0) &&
                        !multiCountry.manualProcessingLoading
                      "
                      >{{ multiCountry.feasibility | number }}</span
                    >
                  </td>
                  <td
                    (click)="
                      multiCountry.psSurveystatus &&
                      multiCountry.psSurveystatus !== surveyStatus.DRAFT
                        ? false
                        : selectDraftSurvey(i)
                    "
                  >
                    {{ multiCountry.expectedIr }}%
                  </td>
                  <td
                    *ngIf="isDraftSaved"
                    class="delete-draft-col"
                    (click)="
                      deleteSurveyDraft(multiCountry, i);
                      $event.stopPropagation()
                    "
                  >
                    <p>delete</p>
                    <span>x</span>
                  </td>
                </tr>
                <tr *ngIf="multiCountry.showConfirmationBox">
                  <td colspan="6">
                    <div class="multicountry-confirm-box">
                      <div class="multicountry-confirm-text">
                        Please confirm the Override CPI value you have entered
                        to the accurate
                      </div>
                      <div class="multicountry-confirm-button">
                        <button
                          type="button"
                          psUiButton
                          (click)="confirmOvervalue(multiCountry)"
                          size="small"
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </table>
            <div class="new-country-table" *ngIf="isDraftSaved">
              <div class="d-flex">
                <ps-ui-select-dropdown
                  class="btn country-dropdown"
                  [dropdownItems]="filteredCountries"
                  [field]="'name'"
                  [loading]="false"
                  [clearSearch]="false"
                  [label]="selectedCountry.name || 'Select Country'"
                  labelNone="Select Country"
                  labelAlignment="start"
                  (selectedItem)="selectCountry($event)"
                >
                </ps-ui-select-dropdown>
                <ps-ui-select-dropdown
                  class="btn country-dropdown"
                  [dropdownItems]="languages"
                  [field]="'name'"
                  [loading]="false"
                  [clearSearch]="false"
                  [disabled]="!languages.length"
                  [firstSelected]="true"
                  labelNone="Select Language"
                  labelAlignment="start"
                  (selectedItem)="setLanguage($event)"
                >
                </ps-ui-select-dropdown>
                <a class="btn link-primary flex-fill" (click)="addNewSurvey()">
                  <em class="fa fa-plus"></em> add country
                </a>
              </div>
            </div>
          </div>
          <div class="text-center" *ngIf="!loader && !isDraftSaved">
            <button
              type="button"
              (click)="saveSurveyDraft()"
              class="btn mc-button"
              psUiButton
              size="large"
              color="primary"
              psUiGtagEvent
              trackOn="click"
              action="multi_country"
              category="Tools"
              [params]="{ event_label: 'Multi Country Surveys Created' }"
            >
              Save as Draft
            </button>
          </div>
          <div class="text-center" *ngIf="!loader && showLaunchAllButton">
            <button
              type="button"
              class="btn mc-button"
              (click)="launchAllSurveyBtnClick()"
              psUiButton
              size="large"
              color="primary"
              psUiGtagEvent
              trackOn="click"
              action="launch_survey"
              category="Survey_Launch"
              [params]="{ event_label: 'Multi Country Surveys Launched' }"
            >
              Launch all Surveys
            </button>
          </div>
          <div class="text-center" *ngIf="loader">
            <img
              alt=""
              src="../../../assets/image/small-loader.gif"
              width="48"
              height="48"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
